module.exports = __webpack_public_path__ + "img/Off Center Stone.52a3dc59.png";